/** حداقل سخت برای شروع بازرسی در onboarding */
export const ONBOARDING_MIN_INSPECT_URLS = 1;

/** اگر کمتر از این باشد، قبل از ارسال هشدار نمایش داده می‌شود */
export const ONBOARDING_LOW_URL_WARNING_THRESHOLD = 10;

/** پیشنهاد برای بازخورد بهتر در نمای کلی */
export const ONBOARDING_RECOMMENDED_INSPECT_URLS = 50;

/** همان سقف job inspect در بقیهٔ اپ */
export const ONBOARDING_MAX_INSPECT_URLS = 200;
